import { WordEntry, StageConfig } from "../types";
import { HIRAGANA_WORDS } from "../data/hiragana_words";
import { RECENT_SET_SIZE, DEBUG } from "../config";

/** 禁則文字パターン */
const FORBIDDEN_PATTERN = /[ゃゅょっぁぃぅぇぉゎ、。！？ー\s\d\w]/;

/** 単語バンク（禁則フィルタ＋フォールバック、null禁止） */
export class WordBank {
  private filtered: WordEntry[];
  private recentTexts: string[] = [];

  constructor() {
    this.filtered = HIRAGANA_WORDS.filter(
      (entry) => !FORBIDDEN_PATTERN.test(entry.text)
    );

    if (DEBUG) {
      console.log(`[WordBank] filtered: ${this.filtered.length} / ${HIRAGANA_WORDS.length}`);
    }
  }

  /** ステージ設定に従ってテキストを返す（null禁止） */
  pick(config: StageConfig): string {
    const wantType = Math.random() < config.wordRatio ? "word" : "sentence";

    // Step1: type + length 範囲で候補抽出
    let candidates = this.filterCandidates(wantType, config.lengthMin, config.lengthMax);

    // Step2: 候補0ならtype反転
    if (candidates.length === 0) {
      const altType = wantType === "word" ? "sentence" : "word";
      candidates = this.filterCandidates(altType, config.lengthMin, config.lengthMax);
    }

    // Step3: まだ0ならlength範囲を±1,±2…と広げる
    if (candidates.length === 0) {
      for (let expand = 1; expand <= 10; expand++) {
        candidates = this.filterCandidates(
          null,
          config.lengthMin - expand,
          config.lengthMax + expand
        );
        if (candidates.length > 0) break;
      }
    }

    // Step4: 最終手段 - 全データからランダム
    if (candidates.length === 0) {
      candidates = [...this.filtered];
    }

    // 重複回避
    const nonRecent = candidates.filter((c) => !this.recentTexts.includes(c.text));
    const pool = nonRecent.length > 0 ? nonRecent : candidates;

    const chosen = pool[Math.floor(Math.random() * pool.length)];

    // recent更新
    this.recentTexts.push(chosen.text);
    if (this.recentTexts.length > RECENT_SET_SIZE) {
      this.recentTexts.shift();
    }

    if (DEBUG) {
      console.log(`[WordBank] picked: "${chosen.text}" (${chosen.type}, len=${chosen.text.length})`);
    }

    return chosen.text;
  }

  private filterCandidates(
    type: "word" | "sentence" | null,
    minLen: number,
    maxLen: number
  ): WordEntry[] {
    return this.filtered.filter((entry) => {
      if (type !== null && entry.type !== type) return false;
      const len = entry.text.length;
      return len >= minLen && len <= maxLen;
    });
  }
}
